import React, { useState } from 'react';
import './EventsMain.css';
import EventList from './EventList';
import EventDetail from './EventDetail';
import CreateEventModal from './CreateEventModal';

const sidebarTabs = [
  { id: 'invited', label: 'Invited' },
  { id: 'going', label: 'Going' },
  { id: 'interested', label: 'Interested' },
  { id: 'hosting', label: 'Hosting' },
  { id: 'past', label: 'Past Events' }
];

const EventsMain = ({ activeTab, setActiveTab, selectedEvent, setSelectedEvent, onBack }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <main className="events-main page-panel">
      <div className="events-main-header">
        <h1>{selectedEvent ? 'Event Details' : 'Your Events'}</h1>
        {!selectedEvent && (
          <button className="create-event-btn" onClick={() => setShowCreateModal(true)}>
            + Create New Event
          </button>
        )}
      </div>

      {!selectedEvent && (
        <div className="events-tabs">
          {sidebarTabs.map(tab => (
            <button
              key={tab.id}
              type="button"
              className={`events-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
      {showCreateModal && (
        <CreateEventModal onClose={() => setShowCreateModal(false)} />
      )}
      {selectedEvent ? (
        <EventDetail event={selectedEvent} onBack={onBack || (() => setSelectedEvent(null))} />
      ) : (
        <EventList activeTab={activeTab} setSelectedEvent={setSelectedEvent} />
      )}
    </main>
  );
};

export default EventsMain;